import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchNextLevel,
  selectLevel,
  selectLevelLoading,
  selectLevelError,
  selectLevelRef,
} from '../store/slices/levelSlice';

/**
 * Custom hook for getting the next level for a specific game
 * Uses the fetchNextLevel async thunk from the levelSlice
 * @param {string} gameName - The name of the game (e.g., 'learndle-word')
 * @returns {Object} Object containing level, loading, error, and refetch function
 */
export const useGetNextLevel = (gameName) => {
  const dispatch = useDispatch();
  const level = useSelector(selectLevel);
  const loading = useSelector(selectLevelLoading);
  const error = useSelector(selectLevelError);
  const levelRef = useSelector(selectLevelRef);
  const lastLevelRefFetched = useRef(null);
  const userId = useSelector((state) => state.childProfile.childProfile?.id);
  // Fetch next level when gameName changes or levelRef changes
  useEffect(() => {
    // Only fetch if we haven't already fetched this levelRef
    if (gameName && lastLevelRefFetched.current !== levelRef && userId) {
      lastLevelRefFetched.current = levelRef;
      dispatch(fetchNextLevel(gameName));
    }
  }, [dispatch, gameName, levelRef, userId]);

  return {
    level,
    loading,
    error,
  };
};
